import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-refunds',
  templateUrl: './track-refunds.component.html',
  styleUrls: ['./track-refunds.component.css']
})
export class TrackRefundsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
